'use client';

import {
  type BaseImageStatus,
  createImageProcessingContext,
} from '@/components/batchToolsComp/layoutContext/ImageProcessingContext';

export type ImageStatus = BaseImageStatus & {
  finalStatus: 'ready' | 'processing' | 'success' | 'failed' | 'timeout';
  showImgState: 'Original' | 'Preview';

  outputHalfUrl: string;
  outputBlurUrl: string;
  isLockedOutput: boolean;
  outputErrorCode: string;
};

// 使用工厂创建图像修复的Context
const { Provider: ImageProcessingProvider, useImageProcessing } =
  createImageProcessingContext<ImageStatus>('photo-restoration');

// 导出水印移除的Context组件和Hook
export { ImageProcessingProvider, useImageProcessing };
